<template>
    <el-select 
        v-model="innerValue"
        value-key="value" 
        :multiple="multiple"
        :disabled="disabled"
        filterable
        clearable
        style="width: 100%"
        popper-class="popper"
        :placeholder="placeholder"
        @change="handleChangeTree"
    >
        <el-option v-for="(item) in options" :value="item" :key="item.value" :label="item.label + (item.describe ? `（${item.describe}）` : '' )" />
    </el-select>
</template>
<script>
import { debounce, getAction } from '@/utils'
export default {
    name: 'BizRelation',
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '请选择',
        },
        value: {
            type: [Array, Object],
            default: () => [],
        },
        eventCode: {
            type: String,
            default: '',
        },
        viewCode: {
            type: String,
            default: '',
        },
        idField: {
            type: String,
            default: '',
        },
        nameField: {
            type: String,
            default: '',
        },
        descField: {
            type: Array,
            default: () => [],
        },
        bizAssignmentRules: {
            type: Array,
            default: () => [],
        }
    },
    data () {
        return {
            treeData: [],
            innerValue: [],
            options: [],
        }
    },
    watch: {
        eventCode (val) {
            if (val) this.fetchOptions(this)
        },
        viewCode (val) {
            if (val) this.fetchOptions(this)
        },
        value: {
            handler(value) {
                if(this.multiple) {
                    this.innerValue = value
                } else {
                    this.innerValue = Array.isArray(value) && value[0]
                }
            },
            immediate: true,
            deep: true
        }
    },
    created () {
        const { eventCode, viewCode, idField, nameField, descField } = this
        const columns = []
        if (eventCode) {
            const getBizList = this.getApi()
            const [action, params] = getAction(getBizList)
            getBizList && action(eventCode, { viewCode, idField, nameField, descField, columns, pageNum: 1, pageSize: 2000, ...params }).then(res => {
                if (res.code === 200) {
                    if (descField) {
                        this.options = res.data.list.map(k => {
                            return { key: k.id, label: k.name, value: k.id, describe: k.describe }
                        })
                    } else {
                        this.options = res.data.list.map(k => {
                            return { key: k.id, label: k.name, value: k.id }
                        })
                    }
                }
            })
        }
    },
    methods: {
        getApi() {
            const { option: { api } } = this.$attrs
            if (!api) return false
            const { getBizList } = api
            if (!getBizList) return false
            return getBizList
        },
        fetchOptions: debounce(_this => {
            const { eventCode, viewCode, idField, nameField, descField } = _this
            if (!eventCode || !viewCode || !idField || !nameField) {
                return
            }
            const columns = []
            _this.options = []
            const getBizList = _this.getApi()
            const [action, params] = getAction(getBizList)
            getBizList && action(eventCode,{ viewCode, idField, nameField, descField, columns, pageNum: 1, pageSize: 999, ...params }).then(res => {
                if (res.code === 200) {
                if (descField) {
                    _this.options = res.data.list.map(k => {
                    return { key: k.id, label: k.name, value: k.id, describe: k.describe }
                    })
                } else {
                    _this.options = res.data.list.map(k => {
                    return { key: k.id, label: k.name, value: k.id }
                    })
                }
                }
            })
        }, 500),
        handleChangeTree () {
            let cacheValue
            if (!this.multiple) {
                cacheValue = [this.innerValue]
            } else {
                cacheValue = this.innerValue
            }
            this.$emit('input', cacheValue)
            this.$emit('change', cacheValue)
            // 有赋值规则的情况下 只考虑单选
            if(Array.isArray(this.bizAssignmentRules) && this.bizAssignmentRules.length) {
                const { option: { api } } = this.$attrs
                const { getNormalDetail } = api
                const [ action ] = getAction(getNormalDetail)
                const evaluation = (value) => {
                    value.key && getNormalDetail && action(this.eventCode, value.key).then(res => {
                        console.log(this.$attrs)
                        const { formData } = this.$attrs
                        console.log(this.bizAssignmentRules)
                        this.bizAssignmentRules.map(item => {
                            const { bizFieldCode, currentFieldCode } = item
                            // formData[currentFieldCode] = res[bizFieldCode]
                            this.$set(formData, currentFieldCode, res.data[bizFieldCode])
                        })
                    })
                }
                if (!this.multiple) {  //单选
                    const [ value ] =  cacheValue
                    evaluation(value)
                } else {  //多选
                    cacheValue.map(value => {
                        evaluation(value)
                    })
                }
            }
        },
        // 远程搜索
        filterOption (query) {},
    },
}
</script>
<style lang="less" scoped>
.popper {
    max-height: 400px;
    overflow: auto;
}
</style>